import { Overlay } from '@angular/cdk/overlay';
import { Component, Input,ChangeDetectionStrategy, AfterViewInit, ChangeDetectorRef, ViewEncapsulation } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { LoadingComponentService } from './loading-component.service';

@Component({
    selector: 'loading',
    templateUrl: './loading.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class LoadingComponent {

    @Input() styling!: string;					//Either one of the following [systemloading-primary, pageloading-primary, dataloading-primary, itemloading-primary]

    @Input() textPosition: string = 'BOTTOM';   //BOTTOM OR RIGHT

    @Input() spinnerDiameter: number = 60;		//Sets the Diameter of the spinner

    @Input() spinnerStrokeWidth: number = 8;

    @Input() id!: string;                        //Sets the id of the loading animation if needing to access it

    @Input() initialLoading!: boolean;           //Sets the initial loading state so that by default the loader doesn't start

    @Input() message!: string;

    @Input() set show(show:boolean){
        if(show){
            setTimeout(()=>{
                this.startLoader()
            })
        }else{
            setTimeout(()=>{
                this.stopLoader()
            })
        }
    }

    // Public

    public flexDirection: string = 'column'

    //Private

    private _showLoader: boolean = false;

    private _loadingCompleted: boolean = false;

    private _loadingComplete: boolean = false;

    private _progressMessage: string | null = null;

    private _progressMessageStack: string[] = []

    /**
     * Constructor
     * 
     * @param _loadingService 
     */
    constructor(
        private _loadingService: LoadingComponentService
    ) {}

    // ---------------------------------------------------------------
    // @ Lfecycle Hooks
    // ---------------------------------------------------------------


    ngOnInit() {
        this._loadingService.register(this)

        if(this.initialLoading) {
            this._showLoader = true;
        }

        switch (this.textPosition) {
            case 'BOTTOM':
                this.flexDirection = 'column';
                break;
            case 'RIGHT':
                this.flexDirection = 'row';
                break;
        }
    }   

    // ---------------------------------------------------------------
    // @ Getters
    // ---------------------------------------------------------------
    
    get loadingComplete() {
        return this._loadingCompleted;
    }

    get showLoader() {
        return this._showLoader
    }

    get progressMessage() {
        return this._progressMessage;
    }


    // ---------------------------------------------------------------
    // @ Public Methods
    // ---------------------------------------------------------------
    
    public startLoader() {
        this._showLoader = true;
    }

    public stopLoader() {
        this._loadingComplete = false;
        this._showLoader = false;
    }

    public completeLoader() {
        this._loadingComplete = true;
    }

    public isLoading() {
        return this._showLoader && !this.loadingComplete
    }

    public setMessage(message: string): void {
        this.message = message
    }

    public setProgressMessage(message: string): void {
        this.message = message;
    }
    
}
